import React from "react";
import { Box, BoxProps } from "@mui/material";

export const FocusedLogo: React.FC<BoxProps> = (props) => {
  return (
    <Box
      component="img"
      src={`${process.env.PUBLIC_URL}/focused_logo.svg`}
      alt="Focused.space"
      {...props}
      sx={{
        width: 32,
        height: 32,
        ...props.sx,
      }}
    />
  );
};
